import React from 'react'
import PropTypes from 'prop-types'
import './_styles.scss'
import CardTop4to10 from '../CardTop4to10'
import CardTop3 from '../CardTop3'

const MiniCardBlue = ({ className, topTitle, rankingTop }) => {
  const customClass = className ? ` ${className}` : ''
  const top4to10Rows = rankingTop.slice(3, 10)

  return (
    <div className={`estadisticas-juegos__mini-card-blue${customClass}`}>
      <div className='estadisticas-juegos__mini-card-blue-top3-space'>
        <h3 className='estadisticas-juegos__mini-card-blue-top3-title-space'>{topTitle}</h3>
        <div className='estadisticas-juegos__mini-card-blue-top3-cards-space'>
          <div className='estadisticas-juegos__mini-card-blue-slot estadisticas-juegos__mini-card-blue-slot--rank2'>
            <CardTop3 rank={2} player={rankingTop[1]} />
          </div>

          <div className='estadisticas-juegos__mini-card-blue-slot estadisticas-juegos__mini-card-blue-slot--rank1'>
            <CardTop3 rank={1} featured={true}  player={rankingTop[0]}/>
          </div>

          <div className='estadisticas-juegos__mini-card-blue-slot estadisticas-juegos__mini-card-blue-slot--rank3'>
            <CardTop3 rank={3} player={rankingTop[2]} />
          </div>
        </div>
      </div>

      <div className='estadisticas-juegos__mini-card-blue-rest-space'>
        {top4to10Rows.map((player, index) => (
          <div key={index} className='estadisticas-juegos__mini-card-blue-rest-row'>
            <CardTop4to10 player={player} />
          </div>
        ))}
      </div>
    </div>
  )
}

MiniCardBlue.propTypes = {
  className: PropTypes.string,
  topTitle: PropTypes.string
}

MiniCardBlue.defaultProps = {
  className: '',
  topTitle: 'Top'
}

export default MiniCardBlue



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/EstadisticasJuegos/Components/MiniCardBlue/index.jsx